import { freightCommodityToLtlCommodity } from '../../../freight-handling-unit-preset/to-handling-unit-preset-payload';

import type { FreightFulfillmentPlanHandlingUnitPreset } from '../../../../types/freight-responses';
import type { FreightPackagingType, LtlHandlingUnit } from '../../../../types/ltl';

/**
 * Merges a seller-saved handling unit preset into the wizard's handling unit form state.
 *
 * Only non-null preset fields overwrite the existing value — null preset fields
 * are skipped so that saving a preset without e.g. dimensions never blanks a
 * field the user has already filled in.
 *
 * `isStackable` maps from `doNotStack` — the backend stores the negation.
 *
 * Commodities are replaced wholesale from the preset's resolved commodities (a preset with no
 * commodities leaves the unit's existing rows untouched). This must happen in the same merge as
 * the HU-level fields below and go through a single `onChange` — splitting it into a second,
 * separate state write let a stale snapshot silently revert dimensions/packaging/quantity.
 *
 * Future: multi-HU — when a preset can carry multiple HUs, this function will
 * receive a single-HU element from the expanded list rather than the flat preset.
 */
export const applyHandlingUnitPresetToUnit = (unit: LtlHandlingUnit, preset: FreightFulfillmentPlanHandlingUnitPreset): LtlHandlingUnit => {
  return {
    ...unit,
    packagingType: preset.packagingType != null ? (preset.packagingType as unknown as FreightPackagingType) : unit.packagingType,
    quantity: preset.quantity != null ? preset.quantity : unit.quantity,
    length: preset.length != null ? preset.length : unit.length,
    width: preset.width != null ? preset.width : unit.width,
    height: preset.height != null ? preset.height : unit.height,
    isStackable: !preset.doNotStack,
    commodities: preset.commodities?.length ? preset.commodities.map(freightCommodityToLtlCommodity) : unit.commodities,
  };
};
